import { z } from 'zod';

export const WOStatus = z.enum([
  'open',
  'waiting-approval',
  'assigned',
  'in-progress',
  'on-hold',
  'waiting-material',
  'waiting-schedule',
  'completed',
  'closed',
  'cancelled',
]);
export type WOStatus = z.infer<typeof WOStatus>;

export const WOPriority = z.enum(['emergency', 'urgent', 'high', 'medium', 'low']);
export type WOPriority = z.infer<typeof WOPriority>;

export const WorkOrderSchema = z.object({
  id: z.string().uuid(),
  code: z.string(), // human-readable WO code (e.g., WO-1234)
  description: z.string().min(1),
  status: WOStatus,
  priority: WOPriority,
  trade: z.string(),
  location: z.string(),
  buildingId: z.string().nullable(),
  assetId: z.string().uuid().nullable(),
  assignedTo: z.string().uuid().nullable(),
  createdBy: z.string().uuid(),
  estimatedHours: z.number().nullable(),
  dueDate: z.string().datetime().nullable(),
  completedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  // External identity
  orgId: z.string().nullable().optional(),
  siteId: z.string().nullable().optional(),
  externalSystem: z.string().nullable().optional(),
  externalId: z.string().nullable().optional(),
  externalRefId: z.string().nullable().optional(),
});

export type WorkOrder = z.infer<typeof WorkOrderSchema>;

export const CreateWorkOrderSchema = WorkOrderSchema.omit({
  id: true,
  code: true,
  status: true,
  completedAt: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateWorkOrder = z.infer<typeof CreateWorkOrderSchema>;
